const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://api.thoughtful-oasis.com';

export default BACKEND_URL;